/**
 * Умолчания для `<Trans>`. Глобально `escapeValue: false` верно для `t()`, но
 * `Trans` разбирает собранную строку как разметку: имя с `</0>` или `A < B` в
 * значении ломало бы текст. Значения экранируются, `shouldUnescape` возвращает
 * символы в тексте. Значения-разметку в `Trans` не передаём. Отдельный файл,
 * чтобы тесты брали то же самое, не поднимая сетевой конфиг i18n.
 */
export const TRANS_DEFAULT_PROPS = {
  tOptions: { interpolation: { escapeValue: true } },
  shouldUnescape: true,
}
